import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Icon, BadgeContent } from "./styled";

const Badge = ({ badgeContent, startAnimate, enabled, onClick }) => (
	<Wrapper onClick={onClick} enabled={enabled}>
		<Icon className="material-icons">notifications</Icon>
		<BadgeContent setAnimate={startAnimate}>{badgeContent}</BadgeContent>
	</Wrapper>
);

Badge.defaultProps = {
	enabled: false,
	startAnimate: false,
	onClick: null
};

Badge.propTypes = {
	badgeContent: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
		.isRequired,
	enabled: PropTypes.bool,
	startAnimate: PropTypes.bool,
	onClick: PropTypes.func
};

export default Badge;
